/* ============================================================
   Erster Produktabschnitt auf dem Smartphone aufgeklappt
   (Claude, 17.09.2026)

   Auf schmalen Displays macht das Theme aus den Reitern ein Akkordeon
   und laesst alle Punkte zugeklappt - der Beschreibungstext war damit
   auf dem Handy unsichtbar, obwohl er die wichtigsten Kaufargumente
   enthaelt. Hier wird lediglich der erste Punkt einmal geoeffnet, und
   zwar ueber die vorhandene Schaltflaeche des Themes. Keine eigene
   Auf-/Zu-Logik, keine Aenderung am Inhalt.
   ============================================================ */
(function () {
  function openFirst() {
    var wrap = document.querySelector('.product-tabs');
    if (!wrap || wrap.dataset.clTabs === 'done') return;
    if (window.innerWidth > 749) return;

    var toggle = wrap.querySelector('.accordion-toggle');
    if (!toggle) return;                                  // Akkordeon noch nicht gebaut
    if (toggle.getAttribute('aria-expanded') === 'true') { // schon offen
      wrap.dataset.clTabs = 'done';
      return;
    }

    var y = window.scrollY;
    toggle.click();
    if (window.scrollY !== y) window.scrollTo(0, y);
    wrap.dataset.clTabs = 'done';
  }

  window.addEventListener('load', function () {
    openFirst();
    setTimeout(openFirst, 400);
    setTimeout(openFirst, 1200);
  });
})();
